import { Col, FormCheckbox, FormGroup, InPageAlert, Input, Row } from '@snsw/react-component-library';
import moment from 'moment';

import React, { useEffect } from 'react';
import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { isEmpty, validateExt } from 'shared/utils/Validation';
import PropTypes from 'prop-types';
import styles from './Declaration.module.scss';

export const Declaration = React.forwardRef((props, ref) => {
  const {
    warning,
    consent,
    fullName: savedFullName = '',
    isFullNameEditable,
    jobTitle: savedJobTitle = '',
    accepted: savedAccepted = undefined,
    onChange,
    showErrors,
    onErrorChange,
  } = props;

  const [fullName, setFullName] = useState(savedFullName);
  const [jobTitle, setJobTitle] = useState(savedJobTitle);
  const [accepted, setAccepted] = useState(savedAccepted);

  const agreementStampText = `I agree to the above on **${moment().format('Do of MMMM YYYY')}**.`;

  useEffect(() => {
    if (showErrors) validate(validators, setErrors, onErrorChange);

    onChange({ fullName, jobTitle, accepted, agreementStampText });
  }, [fullName, jobTitle, accepted]);

  const validators = [
    {
      fieldName: 'fullName',
      fieldValue: fullName,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Your full name is required.',
    },
    {
      fieldName: 'accepted',
      fieldValue: accepted,
      isValid: () => accepted === true,
      errorMessage: () => 'Declaration checkbox is required.',
    },
  ];

  const [errors, setErrors] = useState({
    fullName: false,
    accepted: false,
  });

  const validate = () => {
    return validateExt(validators, setErrors, onErrorChange);
  };

  if (ref) {
    ref.current = {
      validate,
    };
  }

  return (
    <>
      {warning && (
        <Row>
          <Col span={8} className={styles.declarationItems}>
            <InPageAlert className={styles.iconFix} variant="warning" title={warning.title}>
              {warning.content}
            </InPageAlert>
          </Col>
        </Row>
      )}

      <Row>
        <Col span={8}>
          <FormGroup
            id="fullName"
            label="Your full name"
            isRequired
            hasError={showErrors && errors.fullName}
            errorMessage={errors?.fullName?.errorMessage}
          >
            <Input
              onChange={(e) => setFullName(e.target.value)}
              value={fullName}
              disabled={!isFullNameEditable}
              inputWidth="xl"
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <FormGroup id="jobTitle" label="Job title (optional)">
            <Input onChange={(e) => setJobTitle(e.target.value)} value={jobTitle} inputWidth="xl" />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <ReactMarkdown linkTarget="_blank">{consent}</ReactMarkdown>

          <div className={styles.margintop24}>
            <FormCheckbox
              id="accepted"
              label={<ReactMarkdown className={styles.stampText}>{agreementStampText}</ReactMarkdown>}
              name="accepted"
              onChange={(v) => {
                if (v === 'checked') {
                  setAccepted(true);
                } else {
                  setAccepted(false);
                }
              }}
              value={'checked'}
              checked={accepted}
              hasError={showErrors && errors.accepted}
              errorMessage={errors?.accepted?.errorMessage}
            />
          </div>
        </Col>
      </Row>
    </>
  );
});

Declaration.displayName = 'Declaration';

Declaration.propTypes = {
  warning: PropTypes.object,
  consent: PropTypes.string,
  fullName: PropTypes.string,
  isFullNameEditable: PropTypes.bool,
  jobTitle: PropTypes.string,
  accepted: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  onErrorChange: PropTypes.func,
};

Declaration.propTypes = {
  isFullNameEditable: true,
};
